<div class="forgot-password-container">
  <div class="forgot-password-box">
    <div class="back-button" (click)="backToLogin()">
      <i class="pi pi-arrow-left"></i> Back to Login
    </div>
    
    <h1 class="title">Forgot Password</h1>
    
    <div *ngIf="!submitted; else successMessage">
      <p class="description">Enter your email address and we'll send you a link to reset your password.</p>
      
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <div class="input-container">
          <label for="email">Email</label>
          <input formControlName="email" id="email" type="email" class="custom-input"
              placeholder="Enter your email address" />
          <app-form-errors [control]="forgotPasswordForm.controls['email']"></app-form-errors>
        </div>
        
        <div class="action-buttons">
          <button pButton type="button" 
                  label="Cancel" 
                  class="p-button-outlined"
                  (click)="backToLogin()"></button>
          <button pButton type="submit" 
                  label="Send Reset Link" 
                  class="p-button custom-btn"
                  [loading]="isSubmitting"
                  [disabled]="isSubmitting"></button>
        </div>
      </form>
    </div>
    
    <ng-template #successMessage>
      <div class="success-message">
        <i class="pi pi-check-circle"></i>
        <h3>Email Sent!</h3>
        <p>We've sent a password reset link to your email address. Please check your inbox and follow the instructions.</p>
        <p class="redirecting">Redirecting to login page...</p>
      </div>
    </ng-template>
  </div>
</div>
